export default class GetQuoteRequestFactory {
  constructor({
    amount,
    cryptoCurrency,
    currency,
    serviceFrom,
    serviceTo,
    isCrypto = false,
    isReceived = false,
  }) {
    this.amount = amount;
    this.cryptoCurrency = cryptoCurrency;
    this.currency = currency;
    this.serviceFrom = serviceFrom;
    this.serviceTo = serviceTo;
    this.isCrypto = isCrypto;
    this.isReceived = isReceived;
  }

  getAmountForCrypto() {
    return {
      crypto_amount: this.amount,
      cryptocurrency: this.cryptoCurrency,
    };
  }

  getAmountForFiat() {
    return {
      fiat_amount: this.amount,
      currency: this.currency,
    };
  }

  build() {
    let amount = this.isCrypto
      ? this.getAmountForCrypto()
      : this.getAmountForFiat();

    if (!this.isReceived) {
      amount.service = this.serviceFrom;

      return {
        sell: amount,
        buy: {
          service: this.serviceTo,
          currency: this.currency,
        },
      };
    }

    amount.service = this.serviceTo;

    return {
      buy: amount,
      sell: {
        service: this.serviceFrom,
        currency: this.currency,
      },
    };
  }
}
